import { Validator } from '../Validator';

export default class EmailService implements Validator {
  // tslint:disable-next-line 
  private emailRegex: RegExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  // tslint:disable-next-line no-any
  public getValidation(email: any, message: string = 'email'): Promise<void> {
    return new Promise(
      (res, error) => {
        if (!email) {
          res();
        }
        if (email && typeof email === 'string' && this.emailRegex.test(email)) {
          res();
        } else {
          error(message);
        }
      });
  } 
}



// WEBPACK FOOTER //
// ./src/services/validation/validators/Email.tsx